import * as images from "../Images";

export const ALL_CHARACTERS = [
  // ILVERMORNY ClassmateS (sorted by last name)
  {
    id: 7,
    name: "Erika Baker",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.EBaker,
  },
  {
    id: 4,
    name: "Bailey-Anna Balders",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.BBalders,
  },
  {
    id: 19,
    name: "Warren Cheredaryk",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.WCheredaryk,
  },
  {
    id: 16,
    name: "Seth Claw",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.SClaw,
  },
  {
    id: 10,
    name: "Jeremiah Collier",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.JCollier,
  },
  {
    id: 14,
    name: "Omari Curtis",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.OCurtis,
  },
  {
    id: 18,
    name: "Tony DeLuca",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.TDeLuca,
  },
  {
    id: 6,
    name: "Colby Engel",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.CEngel,
  },
  {
    id: 8,
    name: "Genesis Firth",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.GFirth,
  },
  {
    id: 11,
    name: "Maddie Gardner",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.MGardner,
  },
  {
    id: 9,
    name: "Harmony",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.Harmony,
  },
  {
    id: 2,
    name: "Anuhea Kelii",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.AKelii,
  },
  {
    id: 13,
    name: "Olivia Law",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.OLAw,
  },
  {
    id: 17,
    name: "Shelby MGH",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.SMGH,
  },
  {
    id: 3,
    name: "Azha Pavan",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.APavan,
  },
  {
    id: 1,
    name: "Ava Robinson",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.ARobinson,
  },
  {
    id: 12,
    name: "Noah Robinson",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.NRobinson,
  },
  {
    id: 15,
    name: "Rome Sanford",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.RSanford,
  },
  {
    id: 5,
    name: "Claire Takahashi",
    type: "Classmate",
    school: "Ilvermorny",
    house: "?",
    src: images.CTakahashi,
  },
  // Ilvermorny Underclassmen
  {
    id: 101,
    name: "Celia Claw",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.CClaw,
  },
  {
    id: 102,
    name: "Gordy Baker",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.GBaker,
  },
  {
    id: 103,
    name: "Heather",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.Heather,
  },
  {
    id: 104,
    name: "Johnny Gardner",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.JGardner,
  },
  {
    id: 105,
    name: "Keyla Collier",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.KCollier,
  },
  {
    id: 106,
    name: "Messiah Firth",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.MFirth,
  },
  {
    id: 107,
    name: "Mitch Cheredaryk",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.MCheredaryk,
  },
  {
    id: 108,
    name: "Willow Vanderhoeven",
    type: "Underclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.WVanderhoeven,
  },
  // Ilvermorny Upperclassmen
  {
    id: 109,
    name: "Antoine Curtis",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.ACurtis,
  },
  {
    id: 110,
    name: "Araminta D'Valliste",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.ADValliste,
  },
  {
    id: 111,
    name: "Brad Baker",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.BBaker,
  },
  {
    id: 112,
    name: "Cason Gardner",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.CGardner,
  },
  {
    id: 113,
    name: "Declan Baker",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.DBaker,
  },
  {
    id: 114,
    name: "Emily Gardner",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.EGardner,
  },
  {
    id: 115,
    name: "Florence Baker",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.FBaker,
  },
  {
    id: 116,
    name: "Ian Baker",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.IBaker,
  },
  {
    id: 117,
    name: "Ingrid Cheredaryk",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.ICheredaryk,
  },
  {
    id: 118,
    name: "Jade Halford",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.JHalford,
  },
  {
    id: 119,
    name: "Jesse Gardner",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.JGardner2,
  },
  {
    id: 120,
    name: "Kamayla Collier",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.KCollier2,
  },
  {
    id: 121,
    name: "Maggie Gardner",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.MGardner2,
  },
  {
    id: 122,
    name: "Marley Gardner",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.MrGardner,
  },
  {
    id: 123,
    name: "Panuk Tuktu",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.PTuktu,
  },
  {
    id: 124,
    name: "Patience",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.Patience,
  },
  {
    id: 125,
    name: "Rio Sanford",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.RSanford2,
  },
  {
    id: 126,
    name: "Tanner Baker",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.TBaker,
  },
  {
    id: 127,
    name: "Valor",
    type: "Upperclassman",
    school: "Ilvermorny",
    house: "?",
    src: images.Valor,
  },

  // ILVERMORNY FACULTY (sorted by last name)
  {
    id: 29,
    name: "Professor Sakari Anana",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.SAnana,
  },
  {
    id: 32,
    name: "Professor Noreen Barbuscio",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.NBarbuscio,
  },
  {
    id: 27,
    name: "Professor Sumaira Bashir",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.SBashir,
  },
  {
    id: 64,
    name: "Mrs. Valentina Carrera",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.VCarrera,
  },
  {
    id: 36,
    name: "Mrs. Wendy Drummond",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.WDrummond,
  },
  {
    id: 30,
    name: "Professor Darby Duncan",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.DDuncan,
  },
  {
    id: 31,
    name: "Professor Russell Hart",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.RHart,
  },
  {
    id: 25,
    name: "Professor Shantella Jackson",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.SJackson,
  },
  {
    id: 20,
    name: "Headmaster Osiris Kisio",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.OKisio,
  },
  {
    id: 26,
    name: "Professor Amy Loo",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.ALoo,
  },
  {
    id: 34,
    name: "Mr. Lloyd McNab",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.LMcNab,
  },
  {
    id: 22,
    name: "Professor Korrie Melvin",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.KMelvin,
  },
  {
    id: 28,
    name: "Professor Calvin Muhoza",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.CMuhoza,
  },
  {
    id: 24,
    name: "Professor Aciano Nyxi",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.ANyxi,
  },
  {
    id: 23,
    name: "Professor Trevor Rogers",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.TRogers,
  },
  {
    id: 21,
    name: "Professor Andrew Siemens",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.ASiemens,
  },
  {
    id: 33,
    name: "Mr. John Tolman",
    type: "Faculty",
    school: "Ilvermorny",
    house: "?",
    src: images.JTolman,
  },

  // HOGWARTS ClassmateS (sorted by last name)
  {
    id: 88,
    name: "Hamish Bulstrode",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.HBulstrode,
  },
  {
    id: 87,
    name: "Graham Carrow",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.GCarrow,
  },
  {
    id: 89,
    name: "Jeanette Fawley",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.JFawley,
  },
  {
    id: 93,
    name: "Sadhbh Kelly",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.SKelly,
  },
  {
    id: 94,
    name: "Veronica Khatib",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.VKhatib,
  },
  {
    id: 92,
    name: "Robbie Macmillan",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.RMacmillen,
  },
  {
    id: 91,
    name: "Lucius Malfoy",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.LMalfoy,
  },
  {
    id: 90,
    name: "Josie Pratt",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.JPratt,
  },
  {
    id: 86,
    name: "Gilda-Gideon Prewett",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.GPrewett,
  },
  {
    id: 95,
    name: "William Zobell",
    type: "Classmate",
    school: "Hogwarts",
    house: "?",
    src: images.WZobell,
  },
  {
    id: 128,
    name: "Catherine Kim",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.CKim2,
  },
  {
    id: 129,
    name: "Dominic Crabbe",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.DCrabbe,
  },
  {
    id: 130,
    name: "Eileen Brown",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.EBrown,
  },
  {
    id: 131,
    name: "Errol Crabbe",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.ECrabbe,
  },
  {
    id: 132,
    name: "Fionna Crabbe",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.FCrabbe,
  },
  {
    id: 133,
    name: "Gretchen Crabbe",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.GCrabbe,
  },
  {
    id: 134,
    name: "Jeannine Paxton",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.JPaxton,
  },
  {
    id: 135,
    name: "Narcissa Black",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.NBlack,
  },
  {
    id: 136,
    name: "Peter Yaxley",
    type: "Underclassman",
    school: "Hogwarts",
    house: "?",
    src: images.PYaxley,
  },
  // Hogwarts Upperclassmen
  {
    id: 137,
    name: "Abraham Crabbe",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.ACrabbe,
  },
  {
    id: 138,
    name: "Arthur Weasley",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.AWeasley,
  },
  {
    id: 139,
    name: "Axel Greer",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.AGreer,
  },
  {
    id: 140,
    name: "Bellatrix Black",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.BBlack,
  },
  {
    id: 141,
    name: "Bertrand Crabbe",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.BCrabbe,
  },
  {
    id: 142,
    name: "Blathnaid Kelly",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.BKelly,
  },
  {
    id: 143,
    name: "Harlow Brown",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.HBrown,
  },
  {
    id: 144,
    name: "Ilona Yaxley",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.IYaxley,
  },
  {
    id: 145,
    name: "Joanne Fawley",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.JFawley2,
  },
  {
    id: 146,
    name: "Molly Prewett",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.MPrewett,
  },
  {
    id: 147,
    name: "Niamh Kelly",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.NKelly,
  },
  {
    id: 148,
    name: "Orflaith Kelly",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.OKelly,
  },
  {
    id: 149,
    name: "Rita Skeeter",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.RSkeeter,
  },
  {
    id: 150,
    name: "Sinclair Carrow",
    type: "Upperclassman",
    school: "Hogwarts",
    house: "?",
    src: images.SCarrow,
  },

  // HOGWARTS FACULTY (sorted by last name)
  {
    id: 50,
    name: "Professor Beery",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Beery,
  },
  {
    id: 51,
    name: "Professor Binns",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Binns,
  },
  {
    id: 52,
    name: "Professor Cox",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Cox,
  },
  {
    id: 53,
    name: "Professor Crouch",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Crouch,
  },
  {
    id: 54,
    name: "Headmaster Dumbledore",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Dumbledore,
  },
  {
    id: 47,
    name: "Hagrid",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Hagrid,
  },
  {
    id: 37,
    name: "Professor Hasegawa",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Hasegawa,
  },
  {
    id: 48,
    name: "Madam Hooch",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Hooch,
  },
  {
    id: 38,
    name: "Professor Janvier",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Janvier,
  },
  {
    id: 39,
    name: "Professor Klein",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Klein,
  },
  {
    id: 40,
    name: "Professor Lorien",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Lorien,
  },
  {
    id: 41,
    name: "Professor Mackenzie",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Mackenzie,
  },
  {
    id: 42,
    name: "Professor McGonagall",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.McGonagall,
  },
  {
    id: 49,
    name: "Madam Pomphrey",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Pomphrey,
  },
  {
    id: 43,
    name: "Professor Riddle",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Riddle,
  },
  {
    id: 44,
    name: "Professor Shacklebolt",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Shacklebolt,
  },
  {
    id: 45,
    name: "Professor Slughorn",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Slughorn,
  },
  {
    id: 46,
    name: "Professor Tripe",
    type: "Faculty",
    school: "Hogwarts",
    house: "?",
    src: images.Tripe,
  },
];
